import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PublicGuard {
  constructor(
    public authService: AuthService,
    private apiService: ApiService,
    private router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const queryString = window.location.search;
    let token: string | null = null;
    const urlParams = new URLSearchParams(queryString);
    token = urlParams.get('token');

    if (token) {
      localStorage.setItem('callback_token', token);
      return true;
    }

    const isAuth = localStorage.getItem('token');
    if (!isAuth) {
      return true;
    }

    // Create navigation extras to preserve query params
    const navigationExtras: NavigationExtras = {
      queryParams: route.queryParams,
      queryParamsHandling: 'preserve'
    };

    this.router.navigate(['/home'], navigationExtras);
    return false;
  }
}